var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_circle",
    clipPath: "url(#clip0_787_1822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9997 3.33337C12.6922 3.33337 10.4366 4.01761 8.51803 5.29956C6.59945 6.58151 5.10411 8.4036 4.22109 10.5354C3.33806 12.6672 3.10702 15.013 3.55718 17.2761C4.00735 19.5392 5.11849 21.618 6.7501 23.2496C8.38171 24.8812 10.4605 25.9924 12.7236 26.4425C14.9867 26.8927 17.3325 26.6617 19.4643 25.7786C21.5961 24.8956 23.4182 23.4003 24.7002 21.4817C25.9821 19.5631 26.6663 17.3075 26.6663 15C26.6663 11.9058 25.4372 8.93839 23.2493 6.75046C21.0613 4.56254 18.0939 3.33337 14.9997 3.33337Z",
    fill: "#E51428"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_787_1822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCircle);
export default __webpack_public_path__ + "static/media/red-circle.2e48a852ad138b497a2e485a7b3eab89.svg";
export { ForwardRef as ReactComponent };